import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Link, useNavigate, NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import "./Login.scss";
import { useMediaQuery, useTheme } from "@mui/material";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FormControl from "@mui/material/FormControl";
// import TextField from '@mui/material/TextField';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from "@mui/material/Modal";
import usercalls from "../../Axios";
import consts from "../../constant";
import { toast, ToastContainer } from "react-toastify";
import newloginLogo from "../../Img/light-mode-logo.png";

import "react-toastify/dist/ReactToastify.css";
import AuthHeader from "./AuthHeader";
import AuthLeft from "./AuthLeft";
import Loader from "../Loader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--clr-bcg)",
  // border: '2px solid #000',
  boxShadow: " rgba(255, 255, 255, 0.24) 0px 3px 8px;",
  borderRadius: "10px",
  outline: "none",
  "@media(max-width:767.98px)": {
    width: "75%",
  },
  p: 4,
};

export default function Forget() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const path = usercalls();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [load, setLoad] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/;
  const regex = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;

  // console.log(md, 'md');

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleClickConfirmShowPassword = () =>
    setShowConfirmPassword((show) => !show);

  const [confPassErr, setConfPassErr] = useState("");

  const checkconfirmpass = (e) => {
    if (password != e) {
      setConfPassErr("Password Mismatching");
    } else {
      setConfPassErr("");
    }
  };
  // const handleSubmit = (event) => {
  //     event.preventDefault();
  //     const data = new FormData(event.currentTarget);
  //     console.log({
  //         email: data.get('email'),
  //         password: data.get('password'),
  //     });
  // };

  const handleSubmit = async () => {
    // toast.success();
    try {
      if (email && !regex.test(email)) {
        toast.error("Invalid Email Format");
      } else {
        setLoad(true);
        const url = `${consts.BackendUrl}/forgot`;
        const payload = {
          email: email,
        };
        const response = await path.postCall({ url, payload });
        const result = await response.json();
        // console.log(result, "result");
        if (result?.success === true) {
          localStorage.setItem("email", email);
          toast.success(result?.message);

          // handleOpen();
          const timer = setTimeout(() => {
            setOpen(false);
            navigate("/reset");
            setLoad(false);
          }, 1500);
          return () => clearTimeout(timer);
        } else {
          setLoad(false);
          toast.error(result.message);
        }
      }
    } catch (error) {
      setLoad(false);
      console.log("🚀 ~ register ~ error:", error);
    }
  };

  useEffect(() => {
    // console.log(
    //   window.localStorage.getItem("email"),
    //   "window.localStorage.getItem('email')"
    // );
    if (window.localStorage.getItem("email")) {
      setEmail(localStorage.getItem("email"));
      localStorage.removeItem("email");
    }
  }, []);

  return (
    <>
      {/* <AuthHeader /> */}

      <ToastContainer />
      <div className="register">
        {load && <Loader />}
        <Grid
          container
          component="main"
          spacing={2}
          sx={{ alignItems: "center", pt: 0, height: !lg && "100vh" }}
          className={!md ? "medium" : ""}
        >
          {lg && (
            <Grid item xs={12} sm={12} md={6} lg={5.5}>
              <AuthLeft />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={6} lg={6.5}>
            <Grid
              container
              sx={{ justifyContent: "center", alignItems: "center" }}
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box
                  sx={{
                    my: md && 3,
                    mx: md && 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    // padding: '28px 25px',
                    maxWidth: "700px",
                    margin: "0 auto",
                    padding: "10px",
                  }}
                >
                  <Typography component="h1" variant="h5" className="c-accout">
                    Forgot Password?
                  </Typography>
                  <Typography className="authe-common">
                    Enter the email address you used when you joined and we'll
                    send you instructions to reset your password.
                  </Typography>

                  <Box
                    component="form"
                    // noValidate
                    // onSubmit={handleSubmit}
                    sx={{ mt: 1, width: "100%" }}
                  >
                    <div className="email-fill">
                      <div className="email-name" style={{ marginTop: "8px" }}>
                        Email <span className="required"> * </span>
                      </div>
                      <TextField
                        className="inputtext-box"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        placeholder="Enter your email address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                    </div>

                    <div className="common-btn">
                      {load ? (
                        <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                          Processing...
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          fullWidth
                          sx={{ mt: 3, mb: 2 }}
                          onClick={handleSubmit}
                        >
                          Reset Password
                        </Button>
                      )}
                    </div>

                    {/* <div className="text-center accnt-sign mt-10">
                      <Link to="/register" variant="body2">
                        Don't have an account? <span>Sign Up</span>
                      </Link>
                    </div>

                    <div className="text-center accnt-sign mt-10">
                      <Link to="/resend" variant="body2">
                        Resend Verification Email? <span>Resend</span>
                      </Link>
                    </div> */}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Modal
          open={open}
          // onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="text-right">
              <HighlightOffIcon onClick={handleClose} />
            </div>
            <div className="text-center">
              <img src={newloginLogo} alt="newloginLogo" width={200} />
            </div>
            <div className="c-accout text-center mt-20">
              Email Sent Successfully
            </div>

            <div className="alraedy mt-10">Kindly Verify your email</div>

            {/* <div className="regbtn mt-10 display-3">
                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          sx={{ mt: 3, mb: 2 }}
                          onClick={() => {
                            navigate("/verify");
                          }}
                        >
                          Verify
                        </Button>
                      </div> */}
          </Box>
        </Modal>
      </div>
    </>
  );
}
